import React from "react"
import type { ButtonProps } from "@chakra-ui/react"
import { Button as ChakraButton } from "@chakra-ui/react"
import { useRequestInProgress } from "lib/api"

export type Props = ButtonProps & {
  children?: React.ReactNode
  disabled?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => Promise<unknown> | void
}

export const Button: React.FC<Props> = ({
  children,
  disabled = false,
  onClick = () => Promise.resolve(),
  ...rest
}) => {
  const [loading, setLoading] = React.useState(false)
  const requestInProgress = useRequestInProgress()
  return (
    <ChakraButton
      isLoading={loading}
      disabled={requestInProgress || disabled}
      onClick={async (e) => {
        const v = onClick(e)
        if ((v as unknown) instanceof Promise) {
          setLoading(true)
          await v
          setLoading(false)
        }
      }}
      {...rest}
    >
      {children}
    </ChakraButton>
  )
}
